export default __webpack_public_path__ + "static/media/ASSETS-11.8fd4f18d.png";